export enum ResponseType {
  AuthorizationCode = 'code',
  Token = 'token',
}

export default ResponseType;
